import { Component, OnInit } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import moment from 'moment';
import { EMPTY, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { SlidesService } from '../../services/slides.service';

@Component({
  selector: 'app-slider',
  standalone: true,
  imports: [HttpClientModule, CommonModule, NgbCarouselModule ],
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss'
})
export class SliderComponent implements OnInit{
  slides: any[] = [];
  // strapiUrl = environment?.apiStrapi;

  constructor(
    private slideService: SlidesService
  ) {}

  ngOnInit() {
    this.slideService.getSlides()
    .subscribe((res) => {
      this.slides = res.slides.map((slide: any) => this.validatePublicationImage(slide)).filter((slide: any) => slide?.id);
    });
  }

  validatePublicationImage(info: any) {
    let today = moment();
    let { publicationStart, publicationEnd, show} = info;

    if ( publicationStart && publicationEnd) {
      let inicio = moment(publicationStart);
      let fin = moment(publicationEnd);
      if ( inicio <= today && today <= fin ) {
        return info;
      }
    }
    if (show) {
      return info;
    }
    return ;
  }

  setMapping(info: any) {
    let {formats, url} = info?.imagen?.data[0].attributes;

    return {
      description: info.Descripcion,
      source: info.redireccionar,
      imageUrl: url,
      imageOptions: formats
    }
  }
}
